import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
    selector: 'app-button-finalized-document',
    template: `
  <button  class="font-sans-3xs usa-button usa-button--accent-warm" [disabled]="isFinalDocument" (click)="onClick($event)">{{label}}</button>
    `,
    standalone: false
})

export class ButtonRendererFinalizedDocumentComponent implements ICellRendererAngularComp {
  params;
  label: string;
  isFinalDocument: boolean;


  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
    if(this.params.node.data.currentVersion === 1)  this.isFinalDocument = true;
  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        parent: this.params
      };
      this.params.onClick(params);
    }
  }
}
